module.exports = "<app-page><payments-filter-sheet [fg]=\"fg\" (filterChanged)=\"onFilterChanged($event)\"></payments-filter-sheet><base-chart class=\"m-t-20 m-b-25 char\" *ngIf=\"existNumbers &amp;&amp; !empty\" [data]=\"pieChartData\" [labels]=\"pieChartLabels\" [chartType]=\"pieChartType\" [options]=\"pieChartOptions\" [colors]=\"pieChartColors\"></base-chart><my-payment-details [paymentSummary]=\"paymentSummary\" [empty]=\"empty\"></my-payment-details></app-page>";


//////////////////
// WEBPACK FOOTER
// ./src/app/accounting/payment/payment-index.component.pug
// module id = 872
// module chunks = 0